import EnhancedPricingModal from "../components/BookTravel/Hotel/EnhancedPricingModal";
import RateInfoModal from "../components/BookTravel/Car/RateInfoModal";
import FareRules from "../components/BookTravel/Air/FareRules";
export default {
    methods: {
        hotelPricingModal(value, session) {
            let details = {
                parent: this,
                component: EnhancedPricingModal,
                props: {
                    sol: value,
                    session: session
                },
                trapFocus: false,
                width: 645,

            }
            this.$buefy.modal.open(details)
        },
        carRateModal(value, searchBody) {
            let details = {
                parent: this,
                component: RateInfoModal,
                props: {
                    sol: value,
                    searchBody: searchBody
                },
                trapFocus: false,
                width: 645,

            }
            this.$buefy.modal.open(details)
        },
        fareRulesModal(journeys) {
            let details = {
                parent: this,
                component: FareRules,
                props: {
                    journeys: journeys
                },
                trapFocus: false,
                width: 700,

            }
            this.$buefy.modal.open(details)
        }
    }
}